(() => {
  /*
   * Pore story: the step crossing the middle of the screen becomes active, and on desktop the sticky
   * photo crossfades to it. One IntersectionObserver with a one-pixel band at mid-screen;
   * nothing runs while the page scrolls.
   */
  const setup = (section) => {
    if (section.dataset.pstoryReady) return;
    section.dataset.pstoryReady = '';
    const steps = [...section.querySelectorAll('[data-pstory-step]')];
    const photos = [...section.querySelectorAll('.glow-pstory__photo')];
    const counter = section.querySelector('[data-pstory-current]');
    if (!steps.length) return;

    const activate = (index) => {
      steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
      photos.forEach((photo, i) => photo.classList.toggle('is-active', i === index));
      if (counter) counter.textContent = String(index + 1).padStart(2, '0');
    };

    activate(0);
    section.classList.add('is-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) activate(steps.indexOf(entry.target));
        });
      },
      { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
    );
    steps.forEach((step) => observer.observe(step));

    /* Back above the first step (the intro): show the first photo again */
    const intro = section.querySelector('.glow-pstory__intro');
    if (intro) {
      new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) activate(0);
        },
        { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
      ).observe(intro);
    }

    /* Desktop only: warm the other photos once the section is near, so a crossfade never waits on the
       network. On phones the stage is hidden and each step loads its own photo lazily. */
    const stage = section.querySelector('.glow-pstory__stage');
    if (!stage || getComputedStyle(stage).display === 'none') return;
    const warm = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        section.querySelectorAll('.glow-pstory__photo img').forEach((image) => {
          if (image.loading === 'lazy') image.loading = 'eager';
        });
        warm.disconnect();
      },
      { rootMargin: '600px 0px' }
    );
    warm.observe(section);
  };

  const init = (scope = document) => {
    if (!('IntersectionObserver' in window)) return;
    scope.querySelectorAll('[data-glow-pstory]').forEach(setup);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
